import React,{useState,useEffect,useRef} from "react";
import AddPreviousEmpModel from "./AddPreviousEmpModel";
import { getNewCondidatePreviousEmpDetailsList } from "../../../Redux/Actions/newJoinerAction";
import { useDispatch,useSelector } from "react-redux";
import {httpDeletePreviousEmpDetails,UpdateCandidatePreviousEmpSalarySlip} from '../../HR/onboarding/api/Calls'
import moment from 'moment';
import { useNavigate } from "react-router-dom";

const AddPreviousEmpDetails = ({tab,userID,setTab}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {previousEmpList} = useSelector((state) => state.NewJoinerReducer);
    const [previous,setPrevious] = useState('');
    const [select,setSelected] = useState([]);

    const [slipOne,setSlipOne] = useState('');
    const [slipTwo,setSlipTwo] = useState('');
    const [slipThree,setSlipThree] = useState('');
    const cancelSliponeRef = useRef(null);
    const cancelSliptwoRef = useRef(null);
    const cancelSlipthreeRef = useRef(null);

    const backPage = () =>{
        setPrevious(3);
        setTab(3);
    }
    const updateHandler = (item) =>{
        setSelected(item)
    }
    const handleDelete = async (id) =>{
        await httpDeletePreviousEmpDetails(id).then((res) => {
            if (res.status) {
                dispatch(getNewCondidatePreviousEmpDetailsList(userID))
                return alert(res.msg);
            } else {
                return alert(res.msg);
            }
        });
    }
    useEffect(()=>{
        dispatch(getNewCondidatePreviousEmpDetailsList(userID))
       
    },[userID])
    const handleOpenPopup = () => {
        setSelected(null);
    };
    const salarysliponeHandler = (e) =>{
        setSlipOne(e.target.files[0]);
    }
    const salarysliptwoHandler = (e) =>{
        setSlipTwo(e.target.files[0])
    }
    const salaryslipthreeHandler = (e) =>{
        setSlipThree(e.target.files[0])
    }
    const submitFinishHandeler = async () => {
    

        const formdata = new FormData();
        formdata.append('user_id',userID);
        formdata.append('slip1',slipOne);
        formdata.append('slip2', slipTwo);
        formdata.append('slip3', slipThree);
        await  UpdateCandidatePreviousEmpSalarySlip(formdata,userID).then((res) =>{
            if (res.status) {
                setSlipOne('')
                setSlipTwo('')
                setSlipThree('')
                navigate('/joining-success');
            }else{
                return alert(res.msg)
            }
        })
    }
    const removeOneSalarySlip = (e) =>{
        e.preventDefault();
        setSlipOne('')
        cancelSliponeRef.current.value = null;
    }
    const removeTwoSalarySlip = (e) =>{
        e.preventDefault();
        setSlipTwo('')
        cancelSliptwoRef.current.value = null;
    }
    const removeThirdSalarySlip = (e) =>{
        e.preventDefault();
        setSlipThree('')
        cancelSlipthreeRef.current.value = null;
    }
    return (
        <>
        <AddPreviousEmpModel edit={select} userID={userID} setSelected={setSelected} />
            <div className={`tab-pane fade ${tab === 4 ? 'active show':''}`} id="previousemploymentdetail" role="tabpanel" aria-labelledby="previousemployment-tab">
                <div className="tab_content">
                    <button className="btn_5 float-end" data-bs-toggle="modal" data-bs-target="#previouscompanydetail" onClick={handleOpenPopup}>Add Previous Employment</button>
                    <div className="dash_white_box_ttl mb25">PREVIOUS EMPLOYMENT DETAIL</div>
                    <table className="monthly_table mt20 mb25">
                        <thead>
                            <tr rowSpan={2}>
                                <th>Company Name</th>
                                <th>Title of Position</th>
                                <th>Name &amp; Phone No. of Supervisor</th>
                                <th>From &amp; Till Date</th>
                                <th>Total CTC including Benefits</th>
                                <th>Address of Employer</th>
                                <th>Reason for Leaving</th>
                                <th style={{ width: '150px' }} className="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {previousEmpList?.length > 0 ?
                            previousEmpList?.map((item, keys) => {
                                return (
                            <tr key={keys}>
                                <td>{item.company_name}</td>
                                <td>{item.position}</td>
                                <td>{item.supervisor} ({item.supervisor_mobno})</td>
                                <td>{moment(item.from_date).format('dd M YYYY')} to {moment(item.to_date).format('dd M YYYY')}</td>
                                <td>{item.supervisor_mobno}</td>
                                <td>{item.address_employer}</td>
                                <td>{item.reason_leaving}</td>
                                <td className="text-right">
                                   
                                    <button className="btn_7 mr05" data-bs-toggle="modal" data-bs-target="#previouscompanydetail" onClick={() => updateHandler(item)}><i className="icon icon-pencil" /></button>
                                    <button className="btn_8" onClick={() => handleDelete(item.id)}><i className="icon icon-cross" /></button>
                                </td>
                            </tr>
                               )})
                               : 
                               <tr>
                                   <td colSpan={8} className="text-center">
                                       <div className="notfound">No Record found</div>
                                   </td>
                               </tr>
                               }
                        </tbody>
                    </table>
                    <div className="joining_blk">
                        <div className="tab_sub_ttl mb00">Previous Company Salary Slip</div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-blk">
                                    <div className="form-label">Slip 1</div>
                                    <div className="form-input input-group">
                                    {slipOne !=''?
                                        <input type="file" name="salaryslipone" ref={cancelSliponeRef} onChange={salarysliponeHandler} className="form-control uploadbtn"  id="salaryslipone" />
                                        :
                                        <input type="file" name="salaryslipone" ref={cancelSliponeRef} onChange={salarysliponeHandler} className="form-control uploadbtn"  id="salaryslipone" />}
                                       {slipOne !=''? <button className="btn_2 btn-2" onClick={removeOneSalarySlip}><i className="icon icon-cross"></i></button>
                                        :''}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-blk">
                                    <div className="form-label">Slip 2</div>
                                    <div className="form-input input-group">
                                    {slipTwo !=''?
                                        <input type="file" name="salarysliptwo" ref={cancelSliptwoRef} onChange={salarysliptwoHandler} className="form-control uploadbtn" id="salarysliptwo" />
                                        :
                                        <input type="file" name="salarysliptwo" ref={cancelSliptwoRef} onChange={salarysliptwoHandler} className="form-control uploadbtn" id="salarysliptwo" />
                                     }
                                    {slipTwo !=''?
                                    <button className="btn_2 btn-2" onClick={removeTwoSalarySlip}><i className="icon icon-cross"></i></button>
                                    :
                                    ''}
                                        </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-blk">
                                    <div className="form-label">Slip 3</div>
                                    <div className="form-input input-group">
                                        {slipThree !=''?
                                        <input type="file" name="salaryslipthree"  ref={cancelSlipthreeRef} className="form-control uploadbtn" id="salaryslipthree" />
                                        :
                                        <input type="file" name="salaryslipthree" ref={cancelSlipthreeRef}  onChange={salaryslipthreeHandler} className="form-control uploadbtn" id="salaryslipthree" />}
                                        {slipThree !=''?
                                        <button className="btn_2 btn-2" onClick={removeThirdSalarySlip}><i className="icon icon-cross"></i></button>
                                        :''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab_footer text-end">
                    <button className="btn_5 float-start" onClick={backPage}>Previous</button>
                    <button className="btn_5" onClick={submitFinishHandeler}>Submit</button>
                    {/* <button className="btn_6 ml10">Cancel</button> */}
                </div>
            </div>
        </>
    )
}
export default AddPreviousEmpDetails;